<div class="layout-column custom-panel full-width full-height">

  <!--Search Box-->
  <!--  <div class="layout-row layout-align-start-center padding-top-10 padding-left-10 padding-right-10 padding-bottom-5">-->

  <!--    <app-bringoz-search-input class="flex"-->
  <!--                              [placeholder]="ngPlaceholder"-->
  <!--                              [query]="queryString"-->
  <!--                              (queryChangeEvent)="onQueryChange($event)">-->

  <!--    </app-bringoz-search-input>-->

  <!--  </div>-->

  <!--  <hr class="main-divider">-->


  <span class="br-body-2 font-weight-400 primary-300 margin-top-10 padding-left-10 padding-right-10" translate>Project's Drafts</span>

  <div class="flex layout-column padding-10">
    <cdk-virtual-scroll-viewport [itemSize]="20" class="flex viewport">
      <div *cdkVirtualFor="let draft of draftsCopy"
           [ngClass]="{'selected': draft.id === selectedDraftId}"
           (click)="onSelect(draft.id)"
           class="item layout-row layout-align-start-center">

        <span class="br-body-2 font-weight-400 primary-300 flex text-ellipsis"
              [ngbTooltip]="draft.name" container="body" openDelay="300" triggers="hover"  placement="top-start">
          {{ draft.name }}
        </span>

        <bringoz-button *ngIf="draft.id === defaultDraftId"
                        type="tertiary"
                        size="fit">

          <bringoz-icon iconName="skill" class="primary-300"></bringoz-icon>

        </bringoz-button>

        <bringoz-button *ngIf="draft.id !== defaultDraftId"
                        type="tertiary"
                        size="fit"
                        (onClick)="onSetDraftAsDefault(draft.id);$event.stopPropagation();">

          <bringoz-icon iconName="skill-outline" class="primary-300"></bringoz-icon>

        </bringoz-button>

      </div>
    </cdk-virtual-scroll-viewport>
  </div>


  <!--  <hr class="main-divider">-->

  <!--  <div class="layout-row layout-align-start-center padding-5">-->
  <!--    <bringoz-button [type]="'outline'"-->
  <!--                    [theme]="'primary'"-->
  <!--                    (onClick)="onReset();$event.stopPropagation();">-->
  <!--      <span>{{'Reset' | translate}}</span>-->
  <!--    </bringoz-button>-->
  <!--    <span class="flex"></span>-->
  <!--    <bringoz-button [type]="'tertiary'"-->
  <!--                    [theme]="'primary'"-->
  <!--                    (onClick)="onCancel();$event.stopPropagation();">-->
  <!--      <span>{{'Cancel' | translate}}</span>-->
  <!--    </bringoz-button>-->
  <!--  </div>-->

</div>
